export const Arrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={5.035} height={9.5} {...props}>
        <path
            fill="#5078e1"
            stroke="#5078e1"
            strokeWidth={0.5}
            d="M.4.982 3.84 4.75.4 8.518a.458.458 0 0 0 0 .606.368.368 0 0 0 .553 0L4.67 5.05a.458.458 0 0 0 0-.606L.953.376a.368.368 0 0 0-.553 0 .458.458 0 0 0 0 .606Z"
        />
    </svg>
)